"use client";
import {
  usePopoverStoreProps
} from "./MG4P3223.js";
import {
  useStore,
  useStoreProps
} from "./EKQEJRUF.js";

// src/hovercard/hovercard-store.ts
import * as Core from "@ariakit/core/hovercard/hovercard-store";
function useHovercardStoreProps(store, update, props) {
  store = usePopoverStoreProps(store, update, props);
  useStoreProps(store, props, "timeout");
  useStoreProps(store, props, "showTimeout");
  useStoreProps(store, props, "hideTimeout");
  return store;
}
function useHovercardStore(props = {}) {
  const [store, update] = useStore(Core.createHovercardStore, props);
  return useHovercardStoreProps(store, update, props);
}

export {
  useHovercardStoreProps,
  useHovercardStore
};
